module.exports = __webpack_public_path__ + "img/btn-zanting.b4251744.png";